// extracted by mini-css-extract-plugin
export default {"copy":"kn1eJmB0Zb0GSxmI5uaK","copyLink":"iBH6qBIDIElv9Jntxan1","input":"gc8PIQeCSdUP0AK05PDg","btn":"jfFMmG0ZfAK9FssQO4ig","btnWithLabel":"VwdVaTPJ9rwyLdZfSpL4"};